import { calculateCountDown } from '@/utils';
import { useEffect, useState } from 'react';

// Countdown component for reset time
export const CountdownTimer = ({
    resetTime,
}: {
    resetTime: string | number | null | undefined;
}) => {
    const [timeLeft, setTimeLeft] = useState<string>('');

    useEffect(() => {
        const updateCountdown = () => {
            if (!resetTime) {
                setTimeLeft('--:--:--');
                return;
            }

            try {
                // Convert resetTime to timestamp (assuming it's in seconds)
                const resetTimestamp =
                    typeof resetTime === 'string'
                        ? parseInt(resetTime) * 1000
                        : resetTime * 1000;

                if (isNaN(resetTimestamp)) {
                    setTimeLeft('Invalid time');
                    return;
                }

                const countdown = calculateCountDown(resetTimestamp);

                if (countdown.left <= 0) {
                    setTimeLeft('Reset now');
                } else {
                    // Show more friendly format for less than 1 hour
                    if (countdown.h === 0) {
                        setTimeLeft(
                            `${countdown.format.split(':').slice(1).join(':')}`,
                        );
                    } else {
                        setTimeLeft(countdown.format);
                    }
                }
            } catch (error) {
                console.error('Error calculating countdown:', error);
                setTimeLeft('Error');
            }
        };

        // Update immediately
        updateCountdown();

        // Update every second
        const interval = setInterval(updateCountdown, 1000);

        return () => clearInterval(interval);
    }, [resetTime]);

    return timeLeft;
};
